import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    alignSelf: "center",
  },
  contentCard: {
    height: 160,
    borderColor: "#666",
    borderWidth: 0.5,
    borderRadius: 8,
    borderColor: "#077A97",
    marginTop: 20,
    paddingHorizontal: 16,
    paddingVertical: 18,
    width: 340,
    shadowColor: "#000",
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },

  textInfo: {
    fontWeight: "bold",
    color: "#2C2C2E",
    lineHeight: 30,
  },
  textDescription: {
    fontWeight: "normal",
  },
  contentEdit: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  imgBank: {
    width: 23,
    height: 19,
    position: "absolute",
    right: 10,
    bottom: 10,
  },
  textBtn: {
    textAlign: "center",
    marginTop: 15,
  },
  textNotFoundAccounts: {
    textAlign: "center",
    marginTop: 10,
    marginBottom: 10,
    fontWeight: "bold",
  },

  btnAdd: {
    height: "auto",
    width: 340,
    borderColor: "#077A97",
    borderWidth: 0.5,
    borderRadius: 8,
    marginTop: 20,
    paddingTop: 12,
    paddingBottom: 40,
    alignItems: "center",
  },

  addIcon: {
    width: 90,
    height: 90,
  },

  textBtn: {
    textAlign: "center",
    marginTop: 15,
    fontWeight: "bold",
  },

  textDescription: {
    fontWeight: "normal",
    textAlign: "center",
  },
});
